import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
export var GridContainer = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: ", ";\n    ", "\n    gap: ", "px;\n"])), function (_ref) {
  var display = _ref.display;
  return display;
}, function (_ref2) {
  var template = _ref2.template;
  switch (template === null || template === void 0 ? void 0 : template.type) {
    case "auto-fill":
    case "auto-fit":
      return "grid-template-columns: repeat(".concat(template.type, ", minmax(").concat(template.minWidth, ", 1fr));");
    case "static":
      return "grid-template-columns: repeat(".concat(template.columns, ", ").concat(template.unit || "1fr", ");");
  }
}, function (_ref3) {
  var gap = _ref3.gap;
  return gap;
});
//# sourceMappingURL=GridContainer.js.map